import AppendInput from '../../../../../component/form/AppendInput';
import InputField from '../../../../../component/form/FormInput';
import { getRoundedOff, getRoundedOffAmount } from '../../../components/TaxesCalculation';

const InvoiceFooter = ({
	additionDiscountAndTax,
	setAdditionDiscountAndTax,
	totalAmount,
	totalDiscountAmount,
	totalTaxesAmount,
	invoiceTable,
	calculateAmount,
	type = 'invoice',
}) => {
	const calculateQuantity = () => {
		return invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.quantity), 0);
	};

	return (
		<div
			style={{
				position: 'fixed',
				bottom: 0,
				width: 'stretch',
				overflow: 'hidden',
				// backgroundColor: '#fff',
				zIndex: 10,
			}}
		>
			{/* Summary Header */}
			<div className="max-w-1297 px-3">
				<div
					className="d-flex align-items-center justify-content-between"
					style={{
						height: '36px',
						padding: '0 2rem',
						fontSize: '14px',
						backgroundColor: '#F6F6F9',
					}}
				>
					<div style={{ fontWeight: 400, color: '#555B67' }}>
						Total Items: <span style={{ fontWeight: 700 }}>{invoiceTable.length}</span>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							fontWeight: 600,
							justifyContent: 'end',
						}}
					>
						{type === 'invoice' && (
							<div style={{ width: '100px', textAlign: 'right' }}>{calculateQuantity()}</div>
						)}
						<div
							style={{
								width: type === 'invoice' && '100px',
								textAlign: type === 'invoice' ? 'right' : 'right',
							}}
						>
							{type === 'invoice'
								? calculateAmount().toFixed(2)
								: `Gross Total (excl. taxes) : ₹${calculateAmount().toFixed(2)}`}
						</div>
					</div>
				</div>
			</div>

			{/* Fixed Footer */}
			<div
				style={{
					borderTop: '1px solid #C3CBDC',
					backgroundColor: '#DADDEC',
					boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
					width: '100%',
				}}
			>
				<div className=" max-w-1297 px-3 py-3">
					<div className="invoice-grid">
						<div className="invoice-item">
							<label className="invoice-label">Discount (%)</label>

							<AppendInput
								label=""
								placeholder="0"
								appendLabel="%"
								type="text"
								autoComplete="off"
								className="custom-append-text"
								value={additionDiscountAndTax?.discount}
								onChange={(valueData) => {
									let value = valueData?.replace(/[^0-9.]/g, '');

									const decimalCount = (value.match(/\./g) || []).length;

									if (decimalCount > 1) {
										value = +value?.slice(0, value.lastIndexOf('.'));
									}

									setAdditionDiscountAndTax((prev) => ({
										...prev,
										discount: value,
									}));
								}}
							/>

							<div className="invoice-info">Discount: ₹{totalDiscountAmount().toFixed(2)}/-</div>
						</div>

						<div className="invoice-item">
							<label className="invoice-label">Adjustment</label>

							<InputField
								value={additionDiscountAndTax.adj}
								type="text"
								autoComplete="off"
								onChange={(valueData) => {
									let value = valueData?.replace(/[^0-9.]/g, '');

									setAdditionDiscountAndTax((prev) => ({
										...prev,
										adj: value,
									}));
								}}
								placeholder="0.00"
							/>

							<div className="invoice-info">
								Adjustments: ₹{additionDiscountAndTax.adj ?? 0.0}/-
							</div>
						</div>

						<div className="invoice-item">
							<label className="invoice-label">Round Off</label>

							<InputField
								value={getRoundedOff(Number(totalAmount()).toFixed(2))}
								type="number"
								autoComplete="off"
								disabled={true}
								onChange={(value) =>
									setAdditionDiscountAndTax((prev) => ({
										...prev,
										round_off: value,
									}))
								}
								placeholder="0.00"
							/>

							<div className="invoice-info">Taxes: ₹{totalTaxesAmount().toFixed(2)}/-</div>
						</div>
					</div>

					<div className="invoice-total-section">
						<div className="invoice-total-label">Bill Total</div>

						<div className="invoice-total-amount">
							₹{getRoundedOffAmount(Number(totalAmount()).toFixed(2))}/-
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InvoiceFooter;
